import { createGlobalStyle } from 'styled-components';

import settings from './settings';

const GlobalStyle = createGlobalStyle`
  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}

  html, body {
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  html {
    height: 100%;
    
    &:not(.wf-active):not(.wf-inactive) * {
      color: transparent !important;
    }
  }

  body {
    min-height: 100%;
    font-size: 14px;
    line-height: 1.5;
    color: ${settings.color.default};
    font-family: ${settings.font.default};
    min-width: 320px;
    padding-top: 60px;
    
    &.bg-gray {
      background-color: ${settings.color.grayLight6};
    }
  }
  
  *, :after, :before {
    box-sizing: border-box;
    outline: none;
  }
  
  table {
    border-collapse: collapse;
  }
  
  img {
    max-width: 100%;
    height: auto;
    vertical-align: top;
  }
  
  
  //Typography
  a {
    color: inherit;
    text-decoration: none;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-weight: 900;
    color: ${settings.color.default};
  }
  
  h1 {
    margin: 0;
    line-height: 1.35;
    font-size: 30px;
    @media (min-width: ${settings.bp.medium.view}) {
      line-height: 1.1;
      font-size: 22px;
    }
  }
  
  h2, h3 {
    margin: 0 0 20px;
    line-height: 1.23;
    font-size: 18px;
  }
  //End Typography
  
  hr {
    padding: 0;
    margin: 0 0 30px;
    border: none;
    border-bottom: 2px solid #000;
  }
  
  
  //Helpers
  .only-mobile {
    @media (min-width: ${settings.bp.medium.view}) {
      display: none;
    }
  }
  
  .only-desktop {
    @media (max-width: calc(${settings.bp.small.view} - 1px)) {
      display: none; 
    }
  }
  //END Helpers
`;

export default GlobalStyle;
